import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MainLayoutModule } from "./layout";
import { I18nModule } from "./i18n/i18n.module";
import { UtilsModule } from "./utils/utils.module";
import { BootstrapModule } from "@app/shared/bootstrap.module";
import { PipesModule } from "./pipes/pipes.module";
import { UserModule } from "./user/user.module";
// import {VoiceControlModule} from "./voice-control/voice-control.module";
import { SmartadminWidgetsModule } from "./widgets/smartadmin-widgets.module";
//import {ChatModule} from "./chat/chat.module";
import { StatsModule } from "./stats/stats.module";
import { InlineGraphsModule } from "./graphs/inline/inline-graphs.module";
import { SmartadminFormsLiteModule } from "./forms/smartadmin-forms-lite.module";
import { SmartProgressbarModule } from "./ui/smart-progressbar/smart-progressbar.module";
//import { CalendarComponentsModule } from "@app/shared/calendar/calendar-components.module";
import { BlockUIModule } from "ng-block-ui";
import { ToastrModule } from 'ngx-toastr';
import { LoginDisclaimerComponent } from "./disclaimer/login-disclaimer/login-disclaimer.component";
import { PrivacyPolicyComponent } from "./disclaimer/privacy-policy/privacy-policy.component";
import { TermsOfUseComponent } from './disclaimer/terms-of-use/terms-of-use.component';
import { AboutUsComponent } from './disclaimer/about-us/about-us.component';
import { UnauthorizedComponent } from "./layout/unauthorized/unauthorized.component";
import { PanelComponent } from "./layout/component/panel/panel.component";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        MainLayoutModule,
        BootstrapModule,
        BlockUIModule.forRoot(),
        ToastrModule.forRoot() // ToastrModule added
    ],
    declarations: [LoginDisclaimerComponent, PrivacyPolicyComponent, TermsOfUseComponent, AboutUsComponent, 
    PanelComponent,
    UnauthorizedComponent],
    exports: [
        CommonModule,
        FormsModule,
        RouterModule,
        UserModule,
        MainLayoutModule,
        BootstrapModule,
        I18nModule,
        UtilsModule,
        PipesModule,
        SmartadminFormsLiteModule,
        SmartProgressbarModule,
        InlineGraphsModule,
        SmartadminWidgetsModule,
        //ChatModule,
        StatsModule,
        PanelComponent
        // VoiceControlModule,
        //CalendarComponentsModule,
    ]
})
export class SharedModule { }
